'use strict';

// EXPORTS //

module.exports = Math.log;
